module.exports = new __parcel__URL__("background.c046bea0.png").toString();